import * as yup from 'yup';

export const productListFormSchema = yup.object().shape({
  products: yup
    .array(
      yup.object().shape({
        id: yup.string(),
        category: yup.string(),
        count: yup.number(),
        label: yup.string(),
        excludeTargets: yup
          .array(yup.string().oneOf(['EXCLUDE_MODIFIERS', 'EXCLUDE_ITEMS']))
          .max(1),
      }),
    )
    .nullable()
    .default([]),
});
